import { useContext, useEffect } from 'react';

import { SocketContext } from '@frontend/contexts';

export function useSocket() {
  const ctx = useContext(SocketContext);
  if (!ctx) {
    throw new Error('useSocket must be used within a SocketProvider');
  }
  return ctx;
}

export function useSocketChannel(channel: string, handler: (data: unknown) => void) {
  const { on, off, connected } = useSocket();

  useEffect(() => {
    if (!connected) return;

    on(channel, handler);

    return () => {
      off(channel, handler);
    };
  }, [channel, connected, handler, on, off]);
}
